import type { Glyph } from "./types";

export const DashboardIcon: Glyph = (props) => (
  <svg viewBox="0 0 50 50" aria-hidden="true" fill="currentColor" {...props}>
    <path d="M23 6L23 23L6 23L6 6L23 6ZM7.5 21.5L21.5 21.5L21.5 7.5L7.5 7.5L7.5 21.5Z" />
    <path d="M23 27L23 44L6 44L6 27L23 27ZM7.5 42.5L21.5 42.5L21.5 28.5L7.5 28.5L7.5 42.5Z" />
    <path d="M44 6L44 23L27 23L27 6L44 6ZM28.5 21.5L42.5 21.5L42.5 7.5L28.5 7.5L28.5 21.5Z" />
    <path d="M44 27L44 44L27 44L27 27L44 27ZM28.5 42.5L42.5 42.5L42.5 28.5L28.5 28.5L28.5 42.5Z" />
  </svg>
);

export default DashboardIcon;
